import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTenderTenderFoldersVersionedFiles } from '~src/services/api';
import { DbFile } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { QueryKeys } from './queryKeys';

interface UseTenderFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
  root_folder_id?: string;
  folder_id?: string;
  tender_id?: string;
  enabled?: boolean;
}
export const useTenderTenderFoldersVersionedFiles = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
    root_folder_id,
    folder_id,
    tender_id,
  }: UseTenderFoldersParams = {},
  queryConfig: QueryConfig<DbFile[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const archiveSettings = useArchiveSettings();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on;

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderTenderFoldersVersionedFilesQuery = useQuery<DbFile[], AxiosError>(
    [
      QueryKeys.tenderTenderFoldersVersionedFiles,
      {
        projectId: String(projectId),
        folder_id,
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
        root_folder_id,
        tender_id,
      },
    ],
    loadTenderTenderFoldersVersionedFiles,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId && isTenderingOn && root_folder_id,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );
  return tenderTenderFoldersVersionedFilesQuery;
};
